import { render, staticRenderFns } from "./cookie-banner.vue?vue&type=template&id=b334c33c"
import script from "./cookie-banner.vue?vue&type=script&lang=js"
export * from "./cookie-banner.vue?vue&type=script&lang=js"
import style0 from "./cookie-banner.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports